
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Shadow06:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 105.281C0 115.783 41.6759 106.347 70.7667 115.371C105.012 126.005 127.968 115.414 128 112.3C128.063 102.51 98.245 102.167 71.5256 91.2161C50.7826 82.7192 0 92.3243 0 105.281Z" fill="#0C0D0D"/>
</svg>

  }
  
